
<div class="checkout-container">

  <h1 class="title">
    Confirmá tu reserva
  </h1>

  <p class="subtitle">
    Revisá que los datos sean correctos antes de continuar
  </p>

  <div class="summary-card">

    <div class="summary-section">
      <div class="label">Recorrido</div>
      <div class="value">{{ route?.name }}</div>
    </div>

    <div class="summary-section">
      <div class="label">Viajes</div>

      <div class="trip-item" *ngFor="let trip of trips">
        {{ trip.date | date:'dd/MM/yyyy HH:mm' }}
      </div>
    </div>

  </div>

  <button class="btn-confirm"
          (click)="ok()"
          [disabled]="loading">

    <fa-icon *ngIf="loading" [icon]="faSpinner" spin="true"></fa-icon>

    <span *ngIf="!loading">Confirmar reserva</span>
    <span *ngIf="loading">Reservando...</span>

  </button>

</div>